import { useState } from 'react';
import BillingPanel from './BillingPanel.jsx';
import BankInvoicePanel from './BankInvoicePanel.jsx';
import './PaymentChoice.css';

export default function PaymentChoice({ internal = false }) {
  const [step, setStep] = useState('start');
  const [method, setMethod] = useState('');

  const choose = (value) => {
    setMethod(value);
  };

  return (
    <section className="sv-payment-choice" aria-label="Оплата подписки">
      {step === 'start' ? (
        <div className="sv-payment-choice-intro">
          <div>
            <h2>Оплата подписки</h2>
            <p>Один платёж — удобным для вас способом.</p>
          </div>
          <button
            type="button"
            className="sv-pay-primary"
            onClick={() => setStep('methods')}
            aria-expanded={false}
          >
            Оплатить
          </button>
        </div>
      ) : (
        <>
          <div className="sv-payment-choice-heading">
            <div>
              <h2>Способ оплаты</h2>
              <p>Выберите способ, затем заполните необходимые поля.</p>
            </div>
            <button
              type="button"
              className="sv-payment-choice-back"
              onClick={() => {
                setMethod('');
                setStep('start');
              }}
            >
              Назад
            </button>
          </div>

          <div
            className="sv-payment-choice-methods"
            role="group"
            aria-label="Способ оплаты"
          >
            <button
              type="button"
              className={method === 'online' ? 'selected' : ''}
              aria-pressed={method === 'online'}
              onClick={() => choose('online')}
            >
              <strong>Картой или СБП</strong>
              <span>Оплата через ЮKassa, подтверждается автоматически</span>
            </button>

            <button
              type="button"
              className={method === 'bank' ? 'selected' : ''}
              aria-pressed={method === 'bank'}
              onClick={() => choose('bank')}
            >
              <strong>По банковскому счёту</strong>
              <span>Для организаций и ИП, с получением счёта PDF</span>
            </button>
          </div>

          {method === 'online' && (
            <div className="sv-payment-choice-content">
              {internal ? (
  <p className="sv-pay-help" role="status">На вашем портале уже действует внутренняя подписка. Дополнительная оплата не требуется.</p>
) : (
  <BillingPanel />
)}
            </div>
          )}

          {method === 'bank' && (
            <div className="sv-payment-choice-content">
              {internal ? (
  <p className="sv-pay-help" role="status">На вашем портале уже действует внутренняя подписка. Дополнительная оплата не требуется.</p>
) : (
  <BankInvoicePanel />
)}
            </div>
          )}
        </>
      )}
    </section>
  );
}
